<div id="customerSupportContainer">
     <section class="bg-light" id="main">
          <div class="container">
               <div class="d-flex justify-content-between align-items-center" id="page-title">
                    <h1 [innerHTML]="'ContactUs' | translator:'base'">Contact Us</h1>
               </div>
               <div class="row">
                    <div class="col-lg-8">
                         <p [innerHTML]="'ContactUsFullHelpText' | translator:'base'">
                              Do you have any questions about accessing a PSP record or wish to enroll in the program?
                              We are happy
                              to help! The PSP customer service team is available Monday through Thursday from 8 AM to 6
                              PM ET, and
                              on Friday from 8 AM to 5 PM ET. To chat with an online representative, click the "LIVE
                              HELP" button in
                              the top-right corner of this page.&nbsp;
                         </p>
                         <p>
                              <span [innerHTML]="'ForMoreInfo' | translator:'base'">For more information visit our
                              </span>
                              <a routerLink="/FAQ" (click)="scrollToTop()"
                                   [title]="'FrequentlyAskedQuestions' | translator:'base'"
                                   [innerHTML]="'FrequentlyAskedQuestions' | translator:'base'">Frequently Asked
                                   Questions</a>.
                         </p>
                         <app-contact-form></app-contact-form>
                    </div>
                    <div class="col-lg-4 sidebar">
                         <div class="card shadow-sm rounded-0 border-0">
                              <div class="card-body">
                                   <h3 class="h5" [innerHTML]="'ContactUsSidebarHoursSubHeading' | translator:'base'">
                                        Customer Service Hours<br></h3>
                                   <p>
                                        <span style="color: rgb(21, 57, 108);"
                                             [innerHTML]="'ContactUsSidebarHoursDates1' | translator:'base'">Monday –
                                             Thursday</span><br>
                                        <span style="color: rgb(21, 57, 108);"
                                             [innerHTML]="'ContactUsSidebarHoursTimes1' | translator:'base'">8 AM – 6 PM
                                             ET</span>
                                   </p>
                                   <p>
                                        <span
                                             [innerHTML]="'ContactUsSidebarHoursDates2' | translator:'base'">Friday</span><br>
                                        <span style="color: rgb(21, 57, 108);"
                                             [innerHTML]="'ContactUsSidebarHoursTimes2' | translator:'base'">8 AM – 5 PM
                                             ET</span>
                                   </p>
                                   <h3 class="h5" [innerHTML]="'ContactUsSidebarEmailSubHeading' | translator:'base'">
                                        Customer Service Email<br></h3>
                                   <p>
                                        <a href="mailto:PSPhelp@tylertech.com"
                                             title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a>
                                   </p>
                                   <h3 class="h5" [innerHTML]="'ContactUsSidebarPhoneSubHeading' | translator:'base'">
                                        Customer Service Phone<br></h3>
                                   <p>
                                        <a href="tel:1-877-642-9499" title="1-877-642-9499">1-877-642-9499</a>
                                   </p>
                                   <hr>
                                   <h3 class="h5" [innerHTML]="'Wiz_Downloads' | translator:'base'">Downloads</h3>
                                   <p>
                                        <a class="btn btn-primary btn-sm"
                                             [href]="updateUrl('##docBaseUrl##/PSPAccountHolderUserManual.pdf')"
                                             [title]="'UserManual' | translator:'base'" target="_blank"
                                             id="linkAHManual" name="linkAHManual" role="button">
                                             <span [innerHTML]="'UserManual' | translator:'base'">User Manual
                                             </span>&nbsp;(PDF)
                                        </a>
                                   </p>
                                   <p>
                                        <a class="btn btn-primary btn-sm text-start" target="_blank"
                                             [title]="'EnrollmentForm' | translator:'base'"
                                             [href]="updateUrl('##docBaseUrl##/PSPMotorCarrierEnrollment.pdf')"
                                             id="lnkEnrollForm" name="lnkEnrollForm">
                                             <span [innerHTML]="'MAHEnrollAgreement' | translator:'base'">Motor Carrier
                                                  Enrollment Form (PDF)</span>&nbsp;(PDF)
                                        </a>
                                   </p>
                                   <p>
                                        <a class="btn btn-primary btn-sm text-start" target="_blank"
                                             [title]="'EnrollmentForm' | translator:'base'"
                                             [href]="updateUrl('##docBaseUrl##/ISPAccountHolderAgreement.pdf')"
                                             id="lnkEnroll" name="lnkEnroll">
                                             <span [innerHTML]="'ISPEnrollAgreement' | translator:'base'">Industry
                                                  Service Provider Enrollment Form (PDF)</span>&nbsp;(PDF)
                                        </a>
                                   </p>
                                   <p>
                                        <a class="btn btn-primary btn-sm text-start"
                                             [href]="updateUrl('##docBaseUrl##/PSPDisclosureandAuthorizationForm.pdf')"
                                             target="_blank" [title]="'DDAF' | translator:'base'" id="ddaf" name="ddaf">
                                             <span [innerHTML]="'DDAF' | translator:'base'">Driver Disclosure and
                                                  Authorization Form</span>&nbsp;(PDF)
                                        </a>
                                   </p>
                                   <p class="small" [innerHTML]="'ContactUsSidebarDownload1' | translator:'base'">
                                        You can download a free PDF viewer below.
                                   </p>
                                   <p>
                                        <a href="http://get.adobe.com/reader/" class="btn btn-outline-primary btn-sm"
                                             target="_blank" rel="noopener noreferrer" role="button"
                                             [innerHTML]="'DownloadPDFButtonText' | translator:'base'">
                                             Download a free PDF viewer (new window)
                                        </a>
                                   </p>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </section>
</div>